import React, { ReactElement } from 'react';
import {
  Button, Td, Th, Tr,
} from 'idsk-react-components';
import PrispevokVestnika from '../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../model/PrispevokVestnikaStepEnum';
import TableArray from './TableArray';
import FilledTableDates2 from './FilledTableDates2';
import scrollToTop from '../../../function/scrollToTop';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const FilledTableRelatedData3 = ({
  onChange,
  prispevokVestnika,
}: Props): ReactElement => (
  <>
    <FilledTableDates2 prispevokVestnika={prispevokVestnika} onChange={onChange} />
    <Tr>
      <Th>
        Vykonáva predpisy Zbierky zákonov SR <span className="idsk-hint optional-message">(nepovinný údaj)</span>
      </Th>
      <Td>
        <TableArray data={prispevokVestnika.vykonavaciePredpisy} itemAttributeToShow="popis" />
      </Td>
      <Td>
        <Button
          size="small"
          buttonStyle="link"
          onClick={() => {
            onChange(PrispevokVestnikaStepEnum.RELATED_DATA_3);
            scrollToTop();
          }}
        >
          Zmeniť
        </Button>
      </Td>
    </Tr>
    <Tr>
      <Th>
        Mení príspevky <span className="idsk-hint optional-message">(nepovinný údaj)</span>
      </Th>
      <Td>
        <TableArray data={prispevokVestnika.meniPrispevky} itemAttributeToShow="menovkaSkratena" />
      </Td>
      <Td>
        <Button
          size="small"
          buttonStyle="link"
          onClick={() => {
            onChange(PrispevokVestnikaStepEnum.RELATED_DATA_3);
          }}
        >
          Zmeniť
        </Button>
      </Td>
    </Tr>
    <Tr>
      <Th>
        Ruší príspevky <span className="idsk-hint optional-message">(nepovinný údaj)</span>
      </Th>
      <Td>
        <TableArray data={prispevokVestnika.rusiPrispevky} itemAttributeToShow="menovkaSkratena" />
      </Td>
      <Td>
        <Button
          size="small"
          buttonStyle="link"
          onClick={() => {
            onChange(PrispevokVestnikaStepEnum.RELATED_DATA_3);
          }}
        >
          Zmeniť
        </Button>
      </Td>
    </Tr>
    <Tr>
      <Th>
        Popis <span className="idsk-hint optional-message">(nepovinný údaj)</span>
      </Th>
      <Td>
        {prispevokVestnika.popis}
      </Td>
      <Td>
        <Button
          size="small"
          buttonStyle="link"
          onClick={() => {
            onChange(PrispevokVestnikaStepEnum.RELATED_DATA_3);
          }}
        >
          Zmeniť
        </Button>
      </Td>
    </Tr>
  </>
);

export default FilledTableRelatedData3;
